module.exports = __webpack_public_path__ + "img/sankaku_65_red.adc2bdb2.png";